<template>
  <div class="flex justify-center py-12">
    <UPagination
      v-if="count > 1"
      :page="currentPage"
      :total="count"
      :page-count="itemsPerPage"
      size="xl"
      :ui="{ wrapper: 'flex gap-1' }"
      :max-pages="5"
      :to="(page: number) => getPageUrl(page)"
    ></UPagination>
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from "nuxt/app";

const props = defineProps<{
  count: number;
  currentPage: number;
  category?: string;
}>();

const runtimeConfig = useRuntimeConfig();
const itemsPerPage = Number(runtimeConfig.public.itemsPerPage);

// Generar URLs según el contexto
const getPageUrl = (page: number) => {
  const { category } = props;
  
  if (category) {
    return page === 1 ? `/${category}` : `/${category}/page/${page}`;
  }
  
  return page === 1 ? '/' : `/page/${page}`;
};
</script>

<style></style>
